//This is just for testing babel transformation

var obj = {
  someShortFunction() {
    console.log("Short syntax method working")
  }
}

export default {
  install(Vue) {
    obj.someShortFunction()
  }
};